import { Card } from "@/components/Card";
import { MainWindow, PageContent } from "@/components/layout/MainWindow";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Player from "@vimeo/player";
import { X } from "lucide-react";
import { useEffect, useState } from "react";

function RouteComponent() {
  const navigate = useNavigate();
  const [iframeEl, setIframeEl] = useState<HTMLIFrameElement | null>(null);

  useEffect(() => {
    if (!iframeEl) return;

    const player = new Player(iframeEl);

    player.on("ended", () => {
      navigate({ to: "/" });
    });
  }, [iframeEl, navigate]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        // Close the video and navigate to the home page
        navigate({ to: "/" });
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  return (
    <MainWindow>
      <PageContent className="flex size-full flex-col justify-center">
        <Card className="relative size-full overflow-hidden p-0">
          <X
            className="absolute top-8 right-8 size-8 cursor-pointer"
            onClick={() => navigate({ to: "/" })}
          />
          <iframe
            ref={setIframeEl}
            src="https://player.vimeo.com/video/1069236190?transparent=1&controls=0&keyboard=0&badge=0&muted=0&autoplay=1&player_id=0&app_id=58479"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            className="inset-0 size-full"
            title="Lasso Sales - Sådan gør du"
          ></iframe>
        </Card>
      </PageContent>
    </MainWindow>
  );
}

export const Route = createFileRoute("/_dashboard/intro-video")({
  component: RouteComponent,
});
